import { render, staticRenderFns } from "./Checkout.vue?vue&type=template&id=37cb4820"
import script from "./checkout.ts?vue&type=script&lang=ts&external"
export * from "./checkout.ts?vue&type=script&lang=ts&external"
import style0 from "./Checkout.vue?vue&type=style&index=0&id=37cb4820&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports